if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();  
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });


      const read_more_btns = this.querySelectorAll('.read_more_btn');
      if(read_more_btns.length) {
        for(const read_more_btn of read_more_btns) {
          const tab_contentEl =  read_more_btn.closest('.tab-content');
          if(tab_contentEl) {
        const toggle_slide_tabEl = tab_contentEl.querySelector('.tab-content__inner');
        if(toggle_slide_tabEl) {
        const toggle_slide_tabHeight = toggle_slide_tabEl.offsetHeight;
        if(toggle_slide_tabHeight > 150) {
           toggle_slide_tabEl.classList.add('toggle_slide_tab');
            read_more_btn.classList.remove('hide');
        }
       
      }
      }
        }
      }
      
      document.addEventListener('click', function(e){
      	let el = e.target;
        if(el.classList.contains('read_more_btn') || el.closest('.read_more_btn')) {
    
      
      if(!el.classList.contains('read_more_btn')) {
      	el = el.closest('.read_more_btn');
      }
      e.preventDefault();
      const tab_contentEl =  el.closest('.tab-content');
      if(tab_contentEl) {
      const toggle_slide_tabEl = tab_contentEl.querySelector('.toggle_slide_tab');
      if(toggle_slide_tabEl) {
        toggle_slide_tabEl.classList.toggle('active');
        el.classList.toggle('active');
      }
      }
    }
      });

      document.addEventListener('click', function(e){
      	let el = e.target;
        if(el.classList.contains('tab-link') || el.closest('.tab-link')) {
    
          if(!el.classList.contains('tab-link')) {
          	el = el.closest('.tab-link');
          }
        e.preventDefault();

          if(el.classList.contains('product-tab-anchor')) {
             return false;
           }
          
          if(el.classList.contains('current')) {
            return false;
          }
        const tabsWrapperEl =  el.closest('.product-tabs');
          if(tabsWrapperEl) {
            
            const prevActiveTabLink = tabsWrapperEl.querySelector('.tab-link.current');
            const prevActiveTabContent = tabsWrapperEl.querySelector('.tab-content.current');
  
            if(prevActiveTabLink) {
              prevActiveTabLink.classList.remove('current');
            }
            if(prevActiveTabContent) {
              prevActiveTabContent.classList.remove('current');
            }

            el.classList.add('current');
            const tabContentIndex =  el.getAttribute('data-tab');
             const tabContentEl =  tabsWrapperEl.querySelector('.tab-content-'+tabContentIndex);
            
            if(tabContentEl) {
              tabContentEl.classList.add('current');
            }
          }
        }
      });

      document.addEventListener('click', function(e){
       	let el = e.target;
         if(el.classList.contains('product-tab-anchor') || el.closest('.product-tab-anchor')) {
     
           if(!el.classList.contains('product-tab-anchor')) {
           	el = el.closest('.product-tab-anchor');
           }
         e.preventDefault();
 
           const tabContentIndex =  el.getAttribute('data-tab');
           const tabsWrapper = document.querySelector('.tabs-wrapper.product-tabs-wrapper');
           if(tabsWrapper) {
             const tabLinkEl = tabsWrapper.querySelector('.tab-link[data-tab="' + tabContentIndex + '"]');
             if(tabLinkEl) {
               tabLinkEl.click();
 
               const header_height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
        const announcement_height = parseFloat(document.documentElement.style.getPropertyValue('--announcement-bar-height'));
 
             $("html, body").animate({
               scrollTop: ($(tabsWrapper).offset().top - header_height - announcement_height)
               }, 300);
               
             }
           }
           
 
 
         }
       });


    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
  }
)};



